import { https } from "./api";

export default class {
  constructor() {
    this.instance = https("/audits");
  }
  getAudits = (params = {}) => {
    return this.instance({
      method: "GET",
      url: `/listAudit`,
      params
    });
  };
  
  getAudit = (params = {}) => {
    return this.instance({
      method: "GET",
      url: `/getAudit`,
      params
    });
  };  

  getPersonalData = preRegistrationId => {
    return this.instance({
      method: "GET",
      url: `/${preRegistrationId}/personalData`
    });
  };

  getContractData = (colligateId, contractId) => {
    return this.instance({
      method: "GET",
      url: `/contract/${colligateId}/${contractId}`
    });
  };

  getAddressByCEP = cep => {
    return this.instance({
      method: "GET",
      url: `/address/${cep}`
    });
  };

  requestSignature = data => {
    return this.instance({
      method: "POST",
      url: `/contract/RequestSignature`,
      data
    });
  };
}
